export const REDIRECTS_WIZARD_TEXT = {
  step: 'redirects',
  title: 'Redirects',
  description:
    'Tell us what to do if the app is not installed when the user scans the QR Code. We can take the user to the app store, open a web page, or open a ',
  linkText: 'deepview.',
  link: 'https://help.branch.io/using-branch/docs/deepviews',
} as const;
